import { format } from 'date-fns';

export const leadsState = {
  leadData: {
    leads: [],
    formattedLeads: [],
    leadsById: {},
    total_leads: null,
  },
  leadAnalytics: {
    types: [],
    mediums: [],
    sources: [],
    history: [],
    total_leads: 0,
  },
};

export const leadsReducer = {
  FETCHING_LEAD_ANALYTICS_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      leadAnalytics: {
        ...state.show.leadAnalytics,
        ...payload,
      },
    },
  }),
  POSTING_LEAD_DATA_SUCCESS: (state, payload) => {
    const index = state.show.leadData.leads.findIndex((item) => item.lead_id === payload.lead_id);
    const selectedLead = state.show.leadData.leads[index];
    selectedLead.lead_meta = payload;

    const updatedLeads = [...state.show.leadData.leads.slice(0, index), selectedLead, ...state.show.leadData.leads.slice(index + 1)];

    const formattedLeads = updatedLeads.map((lead) => {
      return {
        id: { value: lead.lead_id },
        'lead type': { value: lead.lead_type, meta: lead.lead_meta },
        source: { value: lead.lead_source },
        'phone name': { value: lead.phone_name },
        medium: { value: lead.lead_medium },
        date: { value: format(new Date(lead.date_created), 'mmm dS h:MMtt') },
      };
    });

    return {
      ...state,
      show: {
        ...state.show,
        leadData: {
          ...state.show.leadData,
          leads: updatedLeads,
          formattedLeads,
        },
      },
    };
  },
};
